module.exports = __webpack_public_path__ + "img/home_hero.9ac98f34.jpg";